import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import util from './../../utils/utils';
import intl from 'react-intl-universal';
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const GET_FIRMWARE_LIST = "GET_FIRMWARE_LIST";
export const GET_RELEASE_LIST = "GET_RELEASE_LIST";
export const FIRMWARE_TYPE = "FIRMWARE_TYPE";




export function updateLoadingStatus(loading) {
    return (dispatch, getState) => {
      dispatch({
        type: UPDATE_LOADING_STATUS,
        loading
      });
    };
}
// 获取产品固件列表
export function getFirmwareList(params={},callback) {
    return (dispatch, getState) => {
      const {
        firmwareId,
        pId,
      } = params;
      const defaultParam = {

        firmwareId,
        pId,
      };
      dispatch(updateLoadingStatus(true));
      const fetchData = new FetchData('/iot/config/api/iot/support/firmware/ota/list', {
        method: "GET",
        body: defaultParam,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      });
      fetchData
        .then(res => {
          dispatch(updateLoadingStatus(false));
          if (res.code == '200') {
            dispatch({
              type: GET_FIRMWARE_LIST,
              firmwareList: res.data || {},
            });
            callback && callback()
          }
        })
        .catch(e => {
          dispatch(updateLoadingStatus(false));
        });
    };
}
// 获取固件种类
export function getFirmwareType(params,callback) {
    return (dispatch, getState) => {
      const defaultParam = {
        moduleId: params.mid,
        pId: params.pId,
      };
      dispatch(updateLoadingStatus(true));
      const fetchData = new FetchData('/iot/config/api/iot/support/firmware/config/list', {
        method: "GET",
        body: defaultParam,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      });
      fetchData
        .then(res => {
            dispatch({
                type: FIRMWARE_TYPE,
                firmwareType:res.data&&res.data || []
              });
              callback&&callback(res.data)  
        })
        .catch(e => {
          dispatch(updateLoadingStatus(false));
        });
    };
}

// 获取发布记录列表
export function getReleaseList(params = {}, callback) {
    return (dispatch, getState) => {

      const { pId, pageIndex ,pageSize } = params;
      const newParams = {
        pId,
        pageIndex: (pageIndex-1) * pageSize,
        pageSize
      }

      dispatch(updateLoadingStatus(true));
      const fetchData = new FetchData('/iot/config/api/iot/support/firmware/ota/record', {
        method: "GET",
        body: newParams,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      });
      fetchData
        .then(res => {
          dispatch(updateLoadingStatus(false));
          if (res.code == '200') {
            const {
                data = [],
                page = {
                  page: 0,
                  size: 10,
                  total: 0
                }
              } = res;
            dispatch({
              type: GET_RELEASE_LIST,
              releaseList: data,
              total: page.total,
              pageIndex,
              pageSize,
            });
            callback && callback()
          }
        })
        .catch(e => {
          dispatch(updateLoadingStatus(false));
        });
    };
}

//删除固件
export function deleteFirmware(defaultParam) {
    return (dispatch, getState) => {
        const {
            pId,
            firmwareId,
            firmwareVersion,
        } = defaultParam
        dispatch(updateLoadingStatus(true));
        const fetchData = new FetchData(`/iot/config/api/iot/support/firmware/ota/delete?pId=${pId}&firmwareId=${firmwareId}&firmwareVersion=${firmwareVersion}`, {
          method: "POST",
          // body:defaultParam,
          metaHandler: {
            403: () => { window.location.href = '/authrization/login'; return; }
          },
        });
        fetchData
          .then(data => {

            if(data && data.code == 200) {
              dispatch(getFirmwareList({firmwareId,pId}))
            } else {
              message.error(data && data.msg);
            }
            dispatch(updateLoadingStatus(false));
          
          })
          .catch(e => {
            dispatch(updateLoadingStatus(false));
            message.error(intl.get('commmon.operate.retry'));
          });
    }
}








  
  